import type { HotelStaticData } from '@/app/components/hotel-detail/common/staticHotelDataAdapter.ts';
import type { OffersData } from '@/app/components/hotel-detail/OffersProvider.tsx';

export const PRODUCT_DETAILS_RESPONSE_CODE_ROOMS = 'OK';

export const getResponseCodeWithoutRooms = (offersData: OffersData | undefined, isPastCheckin: boolean) =>
  !offersData?.responseCode && isPastCheckin ? 'PAST_DATES' : (offersData?.responseCode ?? 'NONE');

export const getAccommodationType = (hotelStaticData: HotelStaticData | null | undefined) =>
  hotelStaticData?.accommodationType || 'HOTELS';

export const getRoomOptionQty = (offersData: OffersData): number =>
  offersData?.rooms?.reduce((acc, cur) => acc + cur.configurations.length, 0) ?? 0;

/**
 * MPH-1060: the vacation-catalog search id to report on detail-page events — the search the PRICING
 * call ran on (taken from the rooms response metadata, see OffersData.pricingVcSearchId), not the one
 * the page was entered with. The two diverge routinely: pricing mints a fresh search whenever the URL
 * id cannot be recovered (stale, absent, or dropped for APEX deeplinks), and a results search
 * completing on the page can overwrite the URL value with an unrelated id.
 *
 * Falls back to the URL value while there is no rooms response to read the id from (pricing or rooms
 * failures), so those events keep the only id they have instead of reporting none.
 */
export const getTrackingVcSearchId = (offersData: OffersData | undefined, urlVcSearchId: string | undefined): string =>
  offersData?.pricingVcSearchId || urlVcSearchId || '';
